import {
  ROLE_PROOF_READER,
  ROLE_SYSTEM_ADMIN,
  ROLE_PROJECT_MNG,
  ROLE_QA_EXPERT,
  ROLE_LSP,
} from '@/utils/const.js';

export default [
  {
    path: '/jobs/:view?/filters/jobs/',
    name: 'jobs',
    component: () => import('@/views/jobs/index.vue'),
    meta: {
      title: 'Jobs list',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_PROOF_READER,
          ROLE_SYSTEM_ADMIN,
          ROLE_PROJECT_MNG,
          ROLE_QA_EXPERT,
          ROLE_LSP,
        ],
      },
    },
  },
  {
    path: '/jobs/detail/:id',
    name: 'job.detail',
    component: () => import('@/views/jobs/job_detail/index.vue'),
    meta: {
      title: 'Jobs detail',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_PROOF_READER,
          ROLE_SYSTEM_ADMIN,
          ROLE_PROJECT_MNG,
          ROLE_QA_EXPERT,
          ROLE_LSP,
        ],
      },
    },
  },
  {
    path: '/jobs/cust_agreement',
    name: 'job.custAgreement',
    component: () => import('@/views/terms/accept_job_terms/index.vue'),
    meta: {
      title: 'Myproof customer agreement',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_PROOF_READER,
          ROLE_SYSTEM_ADMIN,
          ROLE_PROJECT_MNG,
          ROLE_QA_EXPERT,
          ROLE_LSP,
        ],
      },
    },
  },
  {
    path: '/jobs/detail/:id/:view?',
    name: 'job.detail.tabsView',
    component: () => import('@/views/jobs/job_detail/index.vue'),
    meta: {
      title: 'Jobs detail',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_PROOF_READER,
          ROLE_SYSTEM_ADMIN,
          ROLE_PROJECT_MNG,
          ROLE_QA_EXPERT,
          ROLE_LSP,
        ],
      },
    },
  },
];
